import React from "react";
import { connect } from "react-redux";
import {
  openModalDebitComp,
  filterDebits,
  setCurrentPageAfterFilter,
  setClearFilterDebit,
} from "../../actions";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import { Grid, FormControlLabel, Checkbox } from "@material-ui/core";
import ButtonTypeName from "../../components/ButtonTypeName";
import { arrayRemoveItem } from "../../helper/arrayRemoveItem";
import { green } from "@material-ui/core/colors";

const styles = (theme) => ({
  menuButtonText: {
    color: "rgb(24, 116, 185)",
    fontSize: 17,
  },
  menuIcon: {
    width: 30,
    marginRight: 7,
  },
  list: {
    width: 250,
  },
  menuContent: {
    background: "#fff",
    width: "auto",
    padding: 20,
  },
  itemMenu: {
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    height: 305,
    padding: "0 10px",
  },
  menuTitleItem: {
    color: "#636363",
    fontWeight: 500,
  },
  label: {
    margin: "0 auto",
  },
  buttonsGroupConfim: {
    display: "flex",
    justifyContent: "flex-end",
    paddingTop: 20,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
});

const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    "&$checked": {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

class DrawerFilterDebits extends React.Component {
  constructor(props) {
    super(props);

    var newItemsSelect = [];
    const updatedData = props.itensMenu.map((item, index, arr) => {
      return {
        ...item,
        Contribuintes: item.Contribuintes.map((contItem) => {
          newItemsSelect.push(contItem.NumInscricao);
          return {
            ...contItem,
          };
        }),
      };
    });

    this.state = {
      idItem: "",
      itensMenu: updatedData,
      newItemsSelected: newItemsSelect,
    };
    this.handleFilterItens();
  }
  
  toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.props.toggleDrawer(open);
    return this.props.clearFilterUnidadeDebit && this.unChecked();
  };

  handleCheckbox = (isChecked, idItem) => {
    const { newItemsSelected } = this.state;
    if (isChecked) {
      this.setState({
        newItemsSelected: [...newItemsSelected, parseInt(idItem)],
      });
    } else {
      this.setState({
        newItemsSelected: arrayRemoveItem(
          this.state.newItemsSelected,
          parseInt(idItem)
        ),
      });
    }
  };

  handleFilterItens = () => {
    this.props.handleMenuDebitsFilter(this.state.newItemsSelected);
    this.props.setCurrentPageAfterFilter(0);
    this.toggleDrawer(false);
  };

  handleCleaterFilterDebit = () => {
    this.props.setClearFilterDebit("todos");
  };

  onChangeBox = (event, dataIndex, contIndex) => {
    let data = this.state.itensMenu;

    var valueCheck = !data[dataIndex].Contribuintes[contIndex].checked;
    this.handleCheckbox(valueCheck, event.target.value);

    data[dataIndex].Contribuintes[contIndex].checked = valueCheck;

    this.setState({
      itensMenu: data,
    });
  };

  unChecked = () => {
    this.setState({
      itensMenu: this.props.itensMenu,
      newItemsSelected: [],
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className="appbar">
        <SwipeableDrawer
          anchor="top"
          open={this.props.controllerDrawer}
          onClose={this.toggleDrawer(false)}
          onOpen={this.toggleDrawer(true)}
        >
          {!this.props.statusError ? (
            <div className={classes.menuContent} role="presentation">
              <Grid container className={classes.container}>
                <Grid item xs={12} sm={2} md={2} className={classes.itemMenu}>
                  <p className={classes.menuTitleItem}>Imóveis</p>
                  {this.state.itensMenu.map((element, elementIndex) => {
                    if (element.Nome === "Imóveis") {
                      return element.Contribuintes.map((item, contIndex) => {
                        return (
                          <FormControlLabel
                            key={item.NumInscricao}
                            control={
                              <GreenCheckbox
                                onChange={(event) =>
                                  this.onChangeBox(
                                    event,
                                    elementIndex,
                                    contIndex
                                  )
                                }
                                checked={item.checked}
                                value={item.NumInscricao}
                                iditem={item.NumInscricao}
                              />
                            }
                            label={
                              item.EnderecoFormatado === null
                                ? item.NumInscricao
                                : item.EnderecoFormatado
                            }
                          />
                        );
                      });
                    }
                    return null;
                  })}
                </Grid>

                <Grid item xs={12} sm={2} md={2} className={classes.itemMenu}>
                  <p className={classes.menuTitleItem}>Estabelecimentos</p>
                  {this.state.itensMenu.map((element, elementIndex) => {
                    if (element.Nome === "Estabelecimentos") {
                      return element.Contribuintes.map((item, contIndex) => {
                        return (
                          <FormControlLabel
                            key={item.NumInscricao}
                            control={
                              <GreenCheckbox
                                onChange={(event) =>
                                  this.onChangeBox(
                                    event,
                                    elementIndex,
                                    contIndex
                                  )
                                }
                                checked={item.checked}
                                value={item.NumInscricao}
                                iditem={item.NumInscricao}
                              />
                            }
                            label={
                              item.EnderecoFormatado === null
                                ? item.NumInscricao
                                : item.EnderecoFormatado
                            }
                          />
                        );
                      });
                    }
                    return null;
                  })}
                </Grid>

                <Grid item xs={12} sm={2} md={2} className={classes.itemMenu}>
                  <p className={classes.menuTitleItem}>Transações de ITIV</p>
                  {this.state.itensMenu.map((element, elementIndex) => {
                    if (element.Nome === "Transações com ITIV") {
                      return element.Contribuintes.map((item, contIndex) => {
                        return (
                          <FormControlLabel
                            key={item.NumInscricao}
                            control={
                              <GreenCheckbox
                                onChange={(event) =>
                                  this.onChangeBox(
                                    event,
                                    elementIndex,
                                    contIndex
                                  )
                                }
                                checked={item.checked}
                                value={item.NumInscricao}
                                iditem={item.NumInscricao}
                              />
                            }
                            label={
                              item.EnderecoFormatado === null
                                ? item.NumInscricao
                                : item.EnderecoFormatado
                            }
                          />
                        );
                      });
                    }
                    return null;
                  })}
                </Grid>

                <Grid item xs={12} sm={2} md={2} className={classes.itemMenu}>
                  <p className={classes.menuTitleItem}>Documentos Fiscais</p>
                  {this.state.itensMenu.map((element, elementIndex) => {
                    if (element.Nome === "Documentos Fiscais") {
                      return element.Contribuintes.map((item, contIndex) => {
                        return (
                          <FormControlLabel
                            key={item.NumInscricao}
                            control={
                              <GreenCheckbox
                                onChange={(event) =>
                                  this.onChangeBox(
                                    event,
                                    elementIndex,
                                    contIndex
                                  )
                                }
                                checked={item.checked}
                                value={item.NumInscricao}
                                iditem={item.NumInscricao}
                              />
                            }
                            label={
                              item.EnderecoFormatado === null
                                ? item.NumInscricao
                                : item.EnderecoFormatado
                            }
                          />
                        );
                      });
                    }
                    return null;
                  })}
                </Grid>

                <Grid item xs={12} sm={2} md={2} className={classes.itemMenu}>
                  <p className={classes.menuTitleItem}>Parcelamentos</p>
                  {this.state.itensMenu.map((element, elementIndex) => {
                    if (element.Nome === "Parcelamentos") {
                      return element.Contribuintes.map((item, contIndex) => {
                        return (
                          <FormControlLabel
                            key={item.NumInscricao}
                            control={
                              <GreenCheckbox
                                onChange={(event) =>
                                  this.onChangeBox(
                                    event,
                                    elementIndex,
                                    contIndex
                                  )
                                }
                                checked={item.checked}
                                value={item.NumInscricao}
                                iditem={item.NumInscricao}
                              />
                            }
                            label={
                              item.EnderecoFormatado === null
                                ? item.NumInscricao
                                : item.EnderecoFormatado
                            }
                          />
                        );
                      });
                    }
                    return null;
                  })}
                </Grid>
              </Grid>

              <div className={classes.buttonsGroupConfim}>
                <div onClick={this.unChecked}>
                  <ButtonTypeName
                    typeButton={7}
                    action={this.toggleDrawer(false)}
                  />
                </div>

                <div onClick={this.unChecked}>
                  <ButtonTypeName typeButton={8} />
                </div>

                <div onClick={this.handleFilterItens}>
                  <ButtonTypeName
                    typeButton={6}
                    action={this.handleCleaterFilterDebit}
                  />
                </div>
              </div>
            </div>
          ) : (
            <p style={{ textAlign: "center", margin: "40px 0" }}>
              Erro ao carregar os dados do menu.
            </p>
          )}
        </SwipeableDrawer>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  openModalDebit: store.cardDebitState.openModalDebitValue,
  valueAmountValue: store.cardDebitState.valueAmountValue,
  debitsSelectedValue: store.cardDebitState.debitsSelectedValue,
  clearFilterUnidadeDebit: store.cardDebitState.clearFilterUnidadeDebit,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModalDebitComp,
      filterDebits,
      setCurrentPageAfterFilter,
      setClearFilterDebit,
    },
    dispatch
  );

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, mapDispatchToProps)(DrawerFilterDebits)
);
